import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PromotionMaterialsService {
    constructor(private apiHttp: ApiHttp) {
    }

    getPromotionMaterials(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post(
            'api/AdminPromotionMaterials/GetPromotionMaterials',
            data,
            messageService);
    }

    addOrUpdatePromotionMaterial(data: FormData, messageService: MessageService): Promise<any> {
        return this.apiHttp.post(
            'api/AdminPromotionMaterials/AddOrUpdatePromotionMaterial',
            data,
            messageService);
    }

    deletePromotionMaterial(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post(
            'api/AdminPromotionMaterials/DeletePromotionMaterial',
            data,
            messageService);
    }
}
